import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-gains-cash',
  templateUrl: './list-gains-cash.component.html',
  styleUrls: ['./list-gains-cash.component.css']
})
export class ListGainsCashComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
